export default __webpack_public_path__ + "static/media/U_wdt_c_cap_0.36ef5c7b.mp3";